import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as archivedProductsState from '../employee-detail.reducer';
import * as archivedProductsReducer from '../reducers/archived-products.reducer';

export const getArchivedProducts = createSelector(archivedProductsState.getArchivedProductsState, archivedProductsReducer.getPastProducts);
